export default class ApprovalPress {
	constructor(node) {
		this.node = node;
		this.approvalFormNode = this.node.querySelector('#form-press-registration-approval');

		this.addListeners();
	}

	static init() {
		let approvalPressNode = document.querySelector("[data-approval-press]");

		if (approvalPressNode) {
			return new ApprovalPress(approvalPressNode);
		}
	}

	addListeners() {
		let _this = this;

		this.approvalFormNode.addEventListener('submit', function(event) {
			event.preventDefault();
			_this.submitApprovalForm();
		});
	}

	submitApprovalForm() {
		var _this = this;
		var responseData = {};

		this.approvalFormNode.classList.add('busy');

		let submittedData = {
			data: {
				uid: this.approvalFormNode.querySelector('input[name="uid"]').value,
				isApproved: document.activeElement.getAttribute("name") === "approve"
			}
		};

		$.ajax({
			type: "POST",
			url: this.approvalFormNode.getAttribute('action'),
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(submittedData),
			dataType: "json",
			success: function(data) {
				responseData = data;

				if (responseData.d.Status === true) {
					_this.approvalFormNode.querySelector('.success-msg').innerHTML = responseData.d.HTML;
				} else {
					_this.approvalFormNode.querySelector('.error-msg').innerHTML = responseData.d.HTML;
				}
			},
			error: function(data) {
				responseData = data;
			},
			complete: function() {
				// console.log(responseData);

				_this.approvalFormNode.classList.remove('busy');
			}
		});
	}
}
